export default __webpack_public_path__ + "static/media/mill.8899c874.mp3";